import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const joinWaitlist = async (email, role) => {
    const res = await axios.post(`${API}/waitlist`, { email, role });
    return res.data;
};

export const getWaitlistCount = async () => {
    const res = await axios.get(`${API}/waitlist/count`);
    return res.data.count;
};